/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 * 
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
/*============================================================================
  LIEN EMAIL "DUO" — ?lpl_add=<variantId>,<variantId>
  A COLLER A LA FIN DE assets/custom.js (depot LE-PETIT-LUNETIER/lpl-theme).

  Permet a un lien d'email d'atterrir sur une page normale du site (collection,
  accueil, fiche produit) avec le tiroir panier deja ouvert et les paires dedans,
  au lieu d'envoyer le client sur /cart, qui est un cul-de-sac.

  Exemple :
    /collections/exclu-web-2?lpl_add=55408027238785,54660669997441

  La chiffonnette offerte n'a rien a faire ici : elle est ajoutee toute seule.
  Le cart:refresh ci-dessous fait re-rendre la section mini-cart, le snippet
  cart-free-gift.liquid re-evalue le panier cote serveur, emet un
  <free-product-data data-action="add">, et updateFreeGifts() de
  section-minicart.js la POSTe. Verifie en direct le 21/10.
==============================================================================*/

(function () {
  var params = new URLSearchParams(window.location.search);
  var raw = params.get('lpl_add');

  if (!raw) {
    return;
  }

  /* Uniquement des ids numeriques, cinq au maximum : le parametre est public. */
  var items = raw.split(',')
    .filter(function (id) { return /^[0-9]{6,20}$/.test(id); })
    .slice(0, 5)
    .map(function (id) { return {id: id, quantity: 1}; });

  /* L'URL est nettoyee dans tous les cas, pour qu'un F5 ne rajoute pas les paires. */
  function nettoieUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete('lpl_add');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  if (!items.length) {
    nettoieUrl();
    return;
  }

  fetch(window.themeVariables.routes.cartUrl + '/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items: items})
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (content) {
          throw new Error(content.description || 'cart/add refuse');
        });
      }
    })
    .then(function () {
      /* Ouvrir AVANT le refresh : le refresh remplace le contenu du tiroir,
         pas le tiroir lui-meme, donc l'attribut open survit. */
      var tiroir = document.getElementById('mini-cart');

      if (tiroir) {
        tiroir.open = true;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    })
    .catch(function (error) {
      console.error('[lpl_add]', error);

      /* Rupture de stock ou variante retiree : on ne laisse pas le client
         devant une page muette, on l'envoie sur le panier. */
      document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
        bubbles: true,
        detail: {status: 'error', error: error.message}
      }));
    })
    .finally(nettoieUrl);
})();
